import React, { Component } from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import ContactSection from '../components/sections/ContactSection';
import TrainersPage from './TrainersPage'

class HomePage extends Component {
  render() {
    return (
      <Box>
        <HeroSection />
        <TrainersPage/>
        <ContactSection />
      </Box>
    );
  }
}

export default HomePage;
